import { MapPinIcon } from '@heroicons/react/24/solid';
import { useMemo } from 'react';

export const DistancePill: React.FC<{ distance: number }> = ({ distance }) => {
  const distanceText = useMemo(() => {
    if (typeof distance !== 'number') return null;
    if (distance < 1000) return `${distance} m`;
    return `${(distance / 1000).toFixed(1)} km`;
  }, [distance]);

  if (!distanceText) return null;

  return (
    <div className="flex items-center gap-1 rounded-full bg-brandBlue-200 px-2 py-0.5 text-brandBlue-800">
      <MapPinIcon className="h-auto w-3" />
      <span className="text-xs font-medium">{distanceText}</span>
    </div>
  );
};
